module.exports = __webpack_public_path__ + "img/couples-038.8f2b5729.jpg";